(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["osr-product"]) return;
  try {
    
  document.querySelectorAll('[data-osr-product]').forEach((root) => {
    if (root.dataset.osrReady === 'true') return;
    root.dataset.osrReady = 'true';
    // 2026-10-17: the title is clamped to two lines on phones; a tap shows the rest.
    const title = root.querySelector('.osr-pdp__title');
    if (title) {
      const markClamp = () => title.classList.toggle('is-clamped', !title.classList.contains('is-open') && title.scrollHeight > title.clientHeight + 2);
      title.addEventListener('click', () => { if (title.classList.contains('is-clamped') || title.classList.contains('is-open')) { title.classList.toggle('is-open'); markClamp(); } });
      requestAnimationFrame(markClamp);
      window.addEventListener('resize', markClamp, { passive: true });
    }
    let mainImage = root.querySelector('.osr-gallery__main-image');
    const galleryStage = root.querySelector('[data-osr-gallery-stage]');
    const galleryItems = Array.from(root.querySelectorAll('[data-osr-gallery-item]'));
    // Thumbnails only. The media slides carry data-osr-media-index too, so the bare
    // attribute selector counted every slide twice and Next ran into empty slots.
    const galleryButtons = Array.from(root.querySelectorAll('.osr-gallery__thumbs [data-osr-media-index]'));
    const galleryCounter = root.querySelector('[data-osr-gallery-current]');
    let galleryIndex = Math.max(0, galleryButtons.findIndex((button) => button.classList.contains('active')));
    const setMainImage = (source, alt = '') => {
      mainImage = root.querySelector('.osr-gallery__main-image');
      if (!mainImage || !source) return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = source;
      if (alt) mainImage.alt = alt;
    };
    const showGalleryMedia = (nextIndex, direction = 1) => {
      if (!galleryButtons.length) return;
      galleryIndex = (nextIndex + galleryButtons.length) % galleryButtons.length;
      const button = galleryButtons[galleryIndex];
      galleryItems.forEach((item, index) => {
        const active = index === galleryIndex;
        item.hidden = !active;
        item.classList.toggle('active', active);
        if (!active) item.querySelectorAll('video').forEach((video) => video.pause());
        if (!active) item.querySelectorAll('iframe').forEach((frame) => frame.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'));
      });
      const activeItem = galleryItems[galleryIndex];
      activeItem?.animate([{ opacity: .45, transform: `translateX(${direction * 10}px) scale(.985)` }, { opacity: 1, transform: 'translateX(0) scale(1)' }], { duration: 190, easing: 'ease-out' });
      galleryButtons.forEach((item, index) => {
        const active = index === galleryIndex;
        item.classList.toggle('active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      if (galleryCounter) galleryCounter.textContent = String(galleryIndex + 1);
      button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      mainImage = activeItem?.querySelector('.osr-gallery__main-image') || root.querySelector('.osr-gallery__main-image');
    };
    galleryButtons.forEach((button) => button.addEventListener('click', () => showGalleryMedia(Number(button.dataset.osrMediaIndex), Number(button.dataset.osrMediaIndex) >= galleryIndex ? 1 : -1)));
    root.querySelector('[data-osr-previous]')?.addEventListener('click', () => showGalleryMedia(galleryIndex - 1, -1));
    root.querySelector('[data-osr-next]')?.addEventListener('click', () => showGalleryMedia(galleryIndex + 1, 1));
    galleryStage?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); showGalleryMedia(galleryIndex - 1, -1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); showGalleryMedia(galleryIndex + 1, 1); }
    });
    let swipeStartX = 0;
    let swipeStartY = 0;
    let swipePointerId = null;
    const finishSwipe = (clientX, clientY) => {
      if (swipePointerId === null) return;
      const distanceX = clientX - swipeStartX;
      const distanceY = clientY - swipeStartY;
      swipePointerId = null;
      if (Math.abs(distanceX) < 38 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
      showGalleryMedia(galleryIndex + (distanceX < 0 ? 1 : -1), distanceX < 0 ? 1 : -1);
    };
    if ('PointerEvent' in window) {
      galleryStage?.addEventListener('pointerdown', (event) => {
        if (event.target.closest('button, a')) return;
        if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
        swipePointerId = event.pointerId;
        swipeStartX = event.clientX;
        swipeStartY = event.clientY;
        // 2026-10-23: no capture on a video slide, or the tap never reaches the video's own play control.
        if (!event.target.closest('video, iframe, model-viewer')) galleryStage.setPointerCapture?.(event.pointerId);
      });
      galleryStage?.addEventListener('pointerup', (event) => {
        if (event.pointerId !== swipePointerId) return;
        finishSwipe(event.clientX, event.clientY);
      });
      galleryStage?.addEventListener('pointercancel', () => { swipePointerId = null; });
    } else {
      galleryStage?.addEventListener('touchstart', (event) => {
        if (event.target.closest('button, a')) return;
        swipePointerId = 0;
        swipeStartX = event.changedTouches[0].clientX;
        swipeStartY = event.changedTouches[0].clientY;
      }, { passive: true });
      galleryStage?.addEventListener('touchend', (event) => {
        finishSwipe(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
      }, { passive: true });
    }
    const relatedTrack = root.querySelector('[data-osr-related-track]');
    const relatedPrevious = root.querySelector('[data-osr-related-previous]');
    const relatedNext = root.querySelector('[data-osr-related-next]');
    const relatedStatus = root.querySelector('[data-osr-related-status]');
    if (relatedTrack) {
      let relatedItems = Array.from(relatedTrack.children);
      // 2026-10-17: snippets/osr-related-shelf.liquid can swap the cards in after load.
      relatedTrack.addEventListener('osr:shelf', () => { relatedItems = Array.from(relatedTrack.children); relatedTrack.scrollLeft = 0; updateRelatedCarousel(); });
      const relatedStep = () => {
        const firstItem = relatedItems[0];
        if (!firstItem) return relatedTrack.clientWidth;
        const gap = parseFloat(getComputedStyle(relatedTrack).columnGap || getComputedStyle(relatedTrack).gap || 0);
        return firstItem.getBoundingClientRect().width + gap;
      };
      const updateRelatedCarousel = () => {
        const step = Math.max(1, relatedStep());
        const index = Math.min(relatedItems.length - 1, Math.max(0, Math.round(relatedTrack.scrollLeft / step)));
        const visibleCount = Math.max(1, Math.round((relatedTrack.clientWidth + parseFloat(getComputedStyle(relatedTrack).columnGap || 0)) / step));
        const lastVisible = Math.min(relatedItems.length, index + visibleCount);
        if (relatedStatus) relatedStatus.textContent = visibleCount > 1 ? `${index + 1}–${lastVisible} / ${relatedItems.length}` : `${index + 1} / ${relatedItems.length}`;
        if (relatedPrevious) relatedPrevious.disabled = relatedTrack.scrollLeft <= 2;
        if (relatedNext) relatedNext.disabled = relatedTrack.scrollLeft + relatedTrack.clientWidth >= relatedTrack.scrollWidth - 2;
      };
      relatedPrevious?.addEventListener('click', () => relatedTrack.scrollBy({ left: -relatedStep(), behavior: 'smooth' }));
      relatedNext?.addEventListener('click', () => relatedTrack.scrollBy({ left: relatedStep(), behavior: 'smooth' }));
      let relatedFrame = 0;
      relatedTrack.addEventListener('scroll', () => {
        cancelAnimationFrame(relatedFrame);
        relatedFrame = requestAnimationFrame(updateRelatedCarousel);
      }, { passive: true });
      window.addEventListener('resize', updateRelatedCarousel);
      requestAnimationFrame(updateRelatedCarousel);
    }
    const quantity = root.querySelector('[data-osr-quantity]');
    const add = root.querySelector('[data-osr-add]');
    const mobileButton = root.querySelector('.osr-pdp__mobile-buy button');
    const total = root.querySelector('[data-osr-total]');
    const mobileTotal = root.querySelector('[data-osr-mobile-total]');
    const mobileQuantity = root.querySelector('[data-osr-mobile-quantity]');
    const currency = root.dataset.currency || 'INR';
    const formatter = new Intl.NumberFormat('en-IN', { style: 'currency', currency });
    const moqMinimum = Math.max(1, Number(root.dataset.osrMoqMinimum || 3));
    const quantityVariantProduct = root.dataset.osrQuantityVariants === 'true';
    const bulkInputs = Array.from(root.querySelectorAll('[data-osr-bulk-quantity]'));

    if (bulkInputs.length) {
      const form = root.querySelector('.osr-pdp__form');
      const bulkPicker = root.querySelector('[data-osr-bulk-picker]');
      const bulkButton = root.querySelector('[data-osr-bulk-add]');
      const bulkStatus = root.querySelector('[data-osr-bulk-status]');
      const bulkCount = root.querySelector('[data-osr-bulk-count]');
      const bulkUnit = root.querySelector('[data-osr-bulk-unit]');
      const bulkTotal = root.querySelector('[data-osr-bulk-total]');
      const setStatus = (message, state = '') => {
        if (!bulkStatus) return;
        bulkStatus.textContent = message;
        bulkStatus.toggleAttribute('data-error', state === 'error');
        bulkStatus.toggleAttribute('data-success', state === 'success');
      };
      const selectedItems = () => bulkInputs.map((input) => {
        const row = input.closest('[data-osr-bulk-row]');
        const count = Math.max(0, Math.floor(Number(input.value) || 0));
        input.value = String(count);
        return { id: Number(row?.dataset.variantId || 0), quantity: count, price: Number(row?.dataset.priceCents || 0), row };
      }).filter((item) => item.id && item.quantity > 0);
      const refreshBulk = () => {
        const items = selectedItems();
        // An "Assorted 6 Pcs" row (data-pack-qty) is 6 pieces towards the minimum.
        const count = items.reduce((sum, item) => sum + item.quantity * (Number(item.row?.dataset.packQty) || 1), 0);
        const cents = items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
        bulkInputs.forEach((input) => input.closest('[data-osr-bulk-row]')?.classList.toggle('is-selected', Number(input.value) > 0));
        if (bulkCount) bulkCount.textContent = String(count);
        if (bulkUnit && quantityVariantProduct) bulkUnit.textContent = count === 1 ? root.dataset.packLabel : root.dataset.packsLabel;
        if (bulkTotal) bulkTotal.textContent = formatter.format(cents / 100);
        // Nothing picked yet: show the per-piece rate and what to do, not "₹0.00 · 0 pieces".
        if (mobileTotal) mobileTotal.textContent = count || !root.dataset.osrEmptyTotal ? formatter.format(cents / 100) : root.dataset.osrEmptyTotal;
        if (mobileQuantity) mobileQuantity.textContent = count || !root.dataset.osrEmptyQty ? `${count} ${quantityVariantProduct ? (count === 1 ? root.dataset.packLabel : root.dataset.packsLabel) : root.dataset.piecesLabel}` : root.dataset.osrEmptyQty;
        const ready = count >= moqMinimum;
        if (bulkButton) bulkButton.disabled = !ready;
        if (mobileButton) mobileButton.disabled = !ready;
        if (!count) setStatus(quantityVariantProduct ? root.dataset.packSelectionLabel : (root.dataset.bulkMinimumLabel || ''));
        else if (!ready) {
          const remaining = moqMinimum - count;
          const label = remaining === 1 ? root.dataset.bulkRemainingOne : root.dataset.bulkRemainingOther;
          setStatus(`${remaining} ${label}`);
        }
        else setStatus('');
        return { items, count, cents, ready };
      };
      const showRowImage = (row) => {
        const image = row?.dataset.image;
        if (!image) return;
        const matchingImage = galleryButtons.findIndex((button) => button.dataset.osrImage === image);
        if (matchingImage >= 0) {
          showGalleryMedia(matchingImage, matchingImage >= galleryIndex ? 1 : -1);
        } else {
          const firstImageIndex = galleryButtons.findIndex((button) => button.dataset.osrImage);
          if (firstImageIndex >= 0) showGalleryMedia(firstImageIndex, firstImageIndex >= galleryIndex ? 1 : -1);
          setMainImage(image);
        }
      };
      root.querySelectorAll('[data-osr-bulk-row]').forEach((row) => {
        const input = row.querySelector('[data-osr-bulk-quantity]');
        row.querySelector('[data-osr-bulk-minus]')?.addEventListener('click', () => {
          input.value = String(Math.max(0, Number(input.value) - 1));
          refreshBulk();
        });
        row.querySelector('[data-osr-bulk-plus]')?.addEventListener('click', () => {
          input.value = String(Math.max(0, Number(input.value)) + 1);
          showRowImage(row);
          refreshBulk();
        });
        input?.addEventListener('input', refreshBulk);
        input?.addEventListener('change', () => { showRowImage(row); refreshBulk(); });
      });
      const addBulk = async () => {
        const selection = refreshBulk();
        if (!selection.ready || !bulkButton) {
          setStatus(root.dataset.bulkMinimumLabel || '', 'error');
          bulkPicker?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        bulkButton.disabled = true;
        if (mobileButton) mobileButton.disabled = true;
        bulkButton.textContent = root.dataset.bulkAddingLabel;
        setStatus('');
        let successMessage = '';
        try {
          const routeRoot = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${routeRoot}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: selection.items.map((item) => {
              const cartItem = { id: item.id, quantity: item.quantity };
              if (quantityVariantProduct) cartItem.properties = { _os_moq_exempt: 'true' };
              return cartItem;
            }) })
          });
          if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.description || error.message || root.dataset.soldOutLabel);
          }
          await response.json();
          bulkInputs.forEach((input) => { input.value = '0'; });
          successMessage = `${selection.count} ${root.dataset.bulkAddedLabel}`;
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { itemCountDelta: selection.count }
          }));
        } catch (error) {
          setStatus(error?.message || root.dataset.soldOutLabel, 'error');
        } finally {
          bulkButton.textContent = root.dataset.bulkAddLabel;
          const current = refreshBulk();
          bulkButton.disabled = !current.ready;
          if (mobileButton) mobileButton.disabled = !current.ready;
          if (successMessage) setStatus(successMessage, 'success');
        }
      };
      bulkButton?.addEventListener('click', addBulk);
      mobileButton?.addEventListener('click', addBulk);
      form?.addEventListener('submit', (event) => { event.preventDefault(); addBulk(); });
      refreshBulk();
    } else {
      const unitPrice = Number(root.dataset.unitPrice || 0);
      // 2026-10-17: sample kits show no total block at one kit; it appears from 2 kits up.
      const totalWrap = root.querySelector('[data-osr-totalwrap]');
      const isKit = root.dataset.osrKit === 'true';
      const refresh = () => {
        const count = Math.max(moqMinimum, Math.floor(Number(quantity?.value || moqMinimum)));
        if (quantity) quantity.value = String(count);
        if (totalWrap && isKit) totalWrap.hidden = count <= 1;
        const formattedTotal = formatter.format((unitPrice * count) / 100);
        if (total) total.childNodes[0].textContent = `${formattedTotal} `;
        if (mobileTotal) mobileTotal.textContent = formattedTotal;
        if (mobileQuantity) mobileQuantity.textContent = `${count} ${root.dataset.piecesLabel}`;
        if (add) add.querySelector('span').textContent = `${root.dataset.addLabel} ${count}`;
      };
      root.querySelector('[data-osr-minus]')?.addEventListener('click', () => { if (quantity) quantity.value = String(Math.max(moqMinimum, Number(quantity.value) - 1)); refresh(); });
      root.querySelector('[data-osr-plus]')?.addEventListener('click', () => { if (quantity) quantity.value = String(Number(quantity.value) + 1); refresh(); });
      quantity?.addEventListener('change', refresh);
      refresh();

      /* 2026-10-17 ADD WITHOUT LEAVING THE PAGE.
         Single-variant products - every sample kit and display tray, and every
         one-colour frame, sunglass, kids frame, clip-on and reader (1,218 of the
         1,733 live products) - had no submit handler here. "Add to cart" (and the
         mobile bar's button, which submits this form) did a plain form POST to
         /cart/add, Shopify redirected to /cart, and the buyer landed on the cart
         page: "Ready to check out" plus a sticky Check out button in the very
         spot Add to cart had been. Multi-colour products never did this: their
         submit goes through addBulk above.
         Now: the same request (FormData of this form, so id + quantity + any
         line-item property the form ever gains) goes to /cart/add.js, the page
         stays, the header count updates (cart:updated) and the shared toast says
         so. "View cart" opens the cart PAGE (data-os-cart-page), where Razorpay
         Magic Checkout runs - not the drawer, whose button goes to native
         /checkout. If fetch itself fails, the plain form post still runs. */
      const form = root.querySelector('.osr-pdp__form');
      const addStatus = root.querySelector('[data-osr-add-status]');
      const routeRoot = window.Shopify?.routes?.root || '/';
      const cartUrl = `${routeRoot}cart`;
      const text = (key, fallback) => addStatus?.dataset[key] || fallback;
      const say = (message, state = '') => {
        if (!addStatus) return;
        addStatus.textContent = message;
        if (state === 'success') {
          const link = document.createElement('a');
          link.href = cartUrl;
          link.setAttribute('data-os-cart-page', '');
          link.textContent = text('viewCart', 'View cart');
          addStatus.append(' · ', link);
        }
        addStatus.toggleAttribute('data-error', state === 'error');
        addStatus.toggleAttribute('data-success', state === 'success');
      };
      let adding = false;
      form?.addEventListener('submit', async (event) => {
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();
        if (adding) return;
        adding = true;
        refresh();
        const count = Math.max(moqMinimum, Math.floor(Number(quantity?.value || moqMinimum)));
        const buttons = [add, mobileButton].filter(Boolean).map((button) => ({ button, disabled: button.disabled, html: button.innerHTML }));
        buttons.forEach(({ button }) => {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          const label = button.querySelector('span') || button;
          label.textContent = text('adding', 'Adding...');
        });
        say('');
        let added = false;
        try {
          const response = await fetch(`${routeRoot}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          const data = await response.json().catch(() => ({}));
          if (response.ok) added = true;
          else say(data.description || data.message || text('error', 'Error adding to cart'), 'error');
        } catch (error) {
          HTMLFormElement.prototype.submit.call(form);
          return;
        } finally {
          adding = false;
          buttons.forEach(({ button, disabled, html }) => {
            button.innerHTML = html;
            button.disabled = disabled;
            button.removeAttribute('aria-busy');
          });
          refresh();
        }
        if (!added) return;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCountDelta: count } }));
        say(text('added', 'Added to cart'), 'success');
        if (typeof window.os2Toast === 'function') {
          window.os2Toast(text('added', 'Added to cart'), cartUrl, text('viewCart', 'View cart'));
          document.querySelector('.os2-toast a')?.setAttribute('data-os-cart-page', '');
        }
        if (mobileButton) {
          const html = mobileButton.innerHTML;
          mobileButton.textContent = `✓ ${text('added', 'Added to cart')}`;
          window.setTimeout(() => { if (!adding) mobileButton.innerHTML = html; }, 1800);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
